export const data = [

    {
        'id':23,
        'title':'35ème édition',
        'image':require('../assets/affiche/affiche2025.png'),
        'nb_part': 4500,
        'nb_ecoles': 115,
        'nb_sports':22,
        'annulee':0,
        'color':'#370b1f',
    },
    {
        'id':1,
        'title':'34ème édition',
        'image':require('../assets/affiche/affiche2024.jpg'),
        'nb_part':4500,
        'nb_ecoles':112,
        'nb_sports':19,
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },

    {
        'id':2,
        'title':'33ème édition',
        'image':require('../assets/affiche/affiche2023.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':20,
        'annulee':0,
        'color':'#370b1f',
    

    },
    {
        'id':2,
        'title':'32ème édition',
        'image':require('../assets/affiche/affiche2022.png'),
        'nb_part':'4500',
        'nb_ecoles':'121',
        'nb_sports':19,
        'annulee':0,
        'color':'#370b1f',
    

    },
    {
        'id':3,
        'title':'32ème édition',
        'image':require('../assets/affiche/affiche2021.jpg'),
        'nb_part':'4500',
        'nb_ecoles':'121',
        'nb_sports':19,
        'annulee':1,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':4,
        'title':'32ème édition',
        'image':require('../assets/affiche/affiche2020.jpeg'),
        'nb_part':'4500',
        'nb_ecoles':'121',
        'nb_sports':19,
        'annulee':1,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':5,
        'title':'31ème édition',
        'image':require('../assets/affiche/affiche2019.jpeg'),
        'nb_part':'4100',
        'nb_ecoles':'112',
        'nb_sports':19,
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':6,
        'title':'30ème édition',
        'image':require('../assets/affiche/affiche2018.jpg'),
        'nb_part':'3900',
        'nb_ecoles':'100',
        'nb_sports':17,
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':7,
        'title':'29ème édition',
        'image':require('../assets/affiche/affiche2017.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':8,
        'title':'28ème édition',
        'image':require('../assets/affiche/affiche2016.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':9,
        'title':'27ème édition',
        'image':require('../assets/affiche/affiche2015.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':10,
        'title':'26ème édition',
        'image':require('../assets/affiche/affiche2014.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':11,
        'title':'25ème édition',
        'image':require('../assets/affiche/affiche2013.png'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':"X",
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':12,
        'title':'24ème édition',
        'image':require('../assets/affiche/affiche2012.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':13,
        'title':'23ème édition',
        'image':require('../assets/affiche/affiche2011.png'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':14,
        'title':'22ème édition',
        'image':require('../assets/affiche/affiche2010.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':15,
        'title':'21ème édition',
        'image':require('../assets/affiche/affiche2009.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':16,
        'title':'20ème édition',
        'image':require('../assets/affiche/affiche2008.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':17,
        'title':'18ème édition',
        'image':require('../assets/affiche/affiche2006.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':18,
        'title':'17ème édition',
        'image':require('../assets/affiche/affiche2005.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':19,
        'title':'16ème édition',
        'image':require('../assets/affiche/affiche2004.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':20,
        'title':'15ème édition',
        'image':require('../assets/affiche/affiche2003.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':21,
        'title':'14ème édition',
        'image':require('../assets/affiche/affiche2002.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    },
    {
        'id':22,
        'title':'13ème édition',
        'image':require('../assets/affiche/affiche2001.jpg'),
        'nb_part':'X',
        'nb_ecoles':'X',
        'nb_sports':'X',
        'annulee':0,
        'textAnnulation':'Annulée pour à cause de la crise sanitaire',
        'color':'#370b1f',
    

    }

]